import { SvgIcon } from "../../common/SvgIcon";
import { SocialLinkProps } from "../types";

export const SocialLink = ({ href, src, alt }: SocialLinkProps) => {
    return (
        <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={alt}
        style={{padding: "0.5rem", marginRight: "1.5rem"}}
        >
            <SvgIcon src={src} alt={alt} width="25px" height="25px"/>
        </a>
    );
};
